// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul.winston li span.ts {
  margin-right: 5px;
}

ul.winston li.level-warn {
  color: #e59400;
}

ul.winston li.level-error {
  color: #be0000;
}

.terminal {
  overflow: hidden scroll;
}

.rows-input {
  text-align: right;
  width: 50px;
  margin-right: 10px;
}

.box-service {
  border-top: 2px solid #6c7e9d;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/pages/SnapshotManagement/Tabs/Terminal/Terminal.css","webpack://./services/frontend/app/pages/SnapshotManagement/Tabs/Terminal/Terminal.css"],"names":[],"mappings":"AADA;ECEE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["ul.winston li span.ts {\n    margin-right: 5px;\n  }\n  ul.winston li.level-warn {\n    color: #e59400;\n  }\n  ul.winston li.level-error {\n    color: #be0000;\n  }\n\n.terminal {\n  overflow: scroll;\n  overflow-x: hidden;\n}\n\n.rows-input {\n  width: 50px;\n  text-align: right;\n  margin-right: 10px;\n}\n\n.box-service {\n  border-top: 2px solid #6c7e9d;\n}\n","ul.winston li span.ts {\n  margin-right: 5px;\n}\n\nul.winston li.level-warn {\n  color: #e59400;\n}\n\nul.winston li.level-error {\n  color: #be0000;\n}\n\n.terminal {\n  overflow: hidden scroll;\n}\n\n.rows-input {\n  text-align: right;\n  width: 50px;\n  margin-right: 10px;\n}\n\n.box-service {\n  border-top: 2px solid #6c7e9d;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
